import {
    CloudOfferingKey,
    CurrencyISOCode,
    OfferingSKUMap
} from "@/components/wpl/pricing/src/price-finder/constants.tsx";
import { CCPOfferingContent } from "@/contentful/product-catalog.tsx";

import {
    calculatePlanPricing,
    FormattedPriceCalculationResponse
} from "./calculate-plan-pricing.ts";
import { ProductCalculationInputs } from "./get-product-calculation-inputs.ts";

export type CalculateProductPricingResult = FormattedPriceCalculationResponse[];

export const calculateProductPricing = (
    ccpPricingData: OfferingSKUMap<CloudOfferingKey, CCPOfferingContent>,
    productCalculationInputs: ProductCalculationInputs,
    currencyISOCode: CurrencyISOCode,
    localeISOCode: string
): CalculateProductPricingResult => {
    const productPricing: FormattedPriceCalculationResponse[] = [];

    for (const planCalculationInputs of productCalculationInputs) {
        const { ccpOfferingSKU, hamsProductKey, numUnits, period } =
            planCalculationInputs;

        const planPricing = calculatePlanPricing({
            ccpPricingData,
            ccpOfferingSKU,
            numUnits,
            period,
            currencyISOCode,
            localeISOCode
        });

        productPricing.push({
            offeringSku: ccpOfferingSKU,
            ...planPricing
        });
    }

    return productPricing;
};
